/**
 * Created by asiulik on 23.11.2017.
 */

define(['jquery', './form__tooltip', '../../utils'], function($, FormTooltip, Utils){

    function Form(){
        this.bindEvents();
    }

    Form.prototype.init = function(){

        this.formTooltip = new FormTooltip();
        this.formTooltip.init();

        try {
            window.ajaxFormBuilderInit();
        } catch(e){}

    };

    Form.prototype.initNewForms = function(){

        this.formTooltip = new FormTooltip();
        this.formTooltip.init();

        try {
            window.ajaxFormBuilderInitOnTheSamePage();
        } catch(e){}

    };

    Form.prototype.bindEvents = function(){

        var _this = this;

        window.addEventListener('formSuccessAction', function(){

            _this.formTooltip.init();
            rebuildMaterialElements();

        });

        window.addEventListener('formSuccessEndAction', function(){
            $("#pageLoader").addClass('preloader--hidden');
            rebuildMaterialElements();
        });

        window.addEventListener('beforeFormAjaxAction', function(){
            $("#pageLoader").removeClass('preloader--hidden');
        });

        window.addEventListener('afterFormAjaxAction', function(event){

            $("#pageLoader").addClass('preloader--hidden');

            var $form = $(event.detail);
            var offset = $form.offset().top;

            Utils.scrollPositionAnimate(offset, 500);

        });
        window.alertClose = function(element) {
            $(element).parent().remove();
        }

        $(document).on({
            click: function(e){
                e.preventDefault();
                var $this = $(this);
                var formId = $this.attr('data-submit-form');
                if(formId){

                    var formInstance = window.getFormInstanceById(formId);

                    formInstance ? formInstance.onFormSubmitForce(
                            $('[data-identifier="' + formId + '"]').find('[type="submit"]').get(0)
                        ) : (function(){})();


                }
            }
        }, '[data-submit-form]');

    };

    function rebuildMaterialElements(){

        try {
            window.Materialize.updateTextFields();
        } catch(e){
        }

        $('select').material_select();

    }

    return Form;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/forms/forms.js